<template lang="html">
  <div class='center-flex'>
    <div class="login-form" @keydown='checkEnter'>
      <div class="maintext">
        <img src="/img/journalisr.png" alt="Journalisr">
        <!-- <h1>Welcome!</h1> -->
        <p>Please give us some details so we can set things up for you.</p>
      </div>
      <input v-model="name" placeholder="name" type="text" name="name" id="nameField">
      <input v-model="email" placeholder="email" type="text" name="email" id="emailField">
      <span class="error-text">{{ errorText }}</span>
      <button ref="button" type="submit" id='submitButton' @click="checkDetails()">
      begin <i class="fas fa-arrow-right"></i></button>
    </div>
  </div>
</template>

<script>
const md5 = require('blueimp-md5')
const uuidv5 = require('uuid/v5')

export default {
  name: 'Register',
  data() {
    return {
      name: '',
      email: '',
      errorText: ''
    }
  },
  mounted() {
    if (this.$parent.dataFormatValid()) {
      this.$router.push({
        name: 'list'
      });
    }
  },
  methods: {
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkDetails() {
      var tests = [this.name.length, this.email.length, this.validateEmail(this.email)],
        messages = ["Please provide a name.", "Please provide an email.", "Invalid email address."]
      for (var i = 0; i < tests.length; i++) {
        if (!tests[i]) {
          this.errorText = messages[i]
          return
        }
      }
      var email = this.email.toLowerCase()
      this.$refs.button.innerHTML = '<i class="fas fa-spin fa-circle-notch"></i>'
      this.$root.data = {}
      this.$root.data.user = {
        "name": this.name,
        "email": email,
        "emailHash": md5(email),
        "uuid": uuidv5(email, 'b64e32e3-6e9c-53d6-8eba-aec6d327d084'),
        "picture": "https://www.gravatar.com/avatar/" + md5(email) + "?s=100&d=identicon"
      }
      this.$root.data.settings = {
        "theme": {
          "name": "Schoolbox",
          "primaryColour": "#4e6d97",
          "accentColour": "#ff8600",
          "shades": ["#374d6b", "#283a59", "#22324d"]
        }
      }
      this.$root.data.journals = {}
      var newJournalName = this.name.split(' ')[0] + "'s Journal"
      this.$parent.createJournal(newJournalName, "## ")
      this.$parent.currentJournal = newJournalName;
      this.$parent.registrationComplete = true;
      this.$parent.$modal.show('welcome')
      this.$router.push({
        name: 'compose'
      });
    },
    checkEnter(event) {
      if (event.key == 'Enter') {
        this.checkDetails()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.maintext {
  width: 300px;
  margin-bottom: 20px;
  color: white;
  text-align: center;
}
.maintext > img {
  width: 260px;
  display: block;
  margin: 0 auto;
}

.main {
    background: var(--shade3);
}
.login-form {
    width: 300px;
    position: relative;
    font-size: small;
    padding-bottom: 70px;
}
.login-form > input {
    display: block;
    margin-bottom: 10px;
    height: 30px;
    background: var(--light);
    width: calc(100% - 6em);
    outline: none;
    padding: 0 3em;
    text-align: center;
    border:none;
}
.login-form > button {
    background: var(--light);
    border: none;
    height: 30px;
    width: 100px;
    /* outline: none; */
    cursor: pointer;
    position: absolute;
    right: 0px;
}
.error-text {
  color: #ff5f5f;
  height: 1em;
  display: block;
  float: left;
}
.login-form > button:hover {
  background: lightgrey;
}
.login-form > input:focus::-webkit-input-placeholder {
    color: transparent;
}

</style>
